/* Good on You · Motion layer
   Lenis smooth scroll + GSAP ScrollTrigger. Alles hier ist Enhancement:
   ohne JS oder mit prefers-reduced-motion bleibt die Seite vollständig lesbar. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  const html = document.documentElement;

  /* ---------- Preloader ---------- */
  const loader = document.getElementById('loader');
  const seen = sessionStorage.getItem('goy-seen');
  const finishLoad = () => { html.classList.add('loaded'); loader?.remove(); };
  if (loader && !reduce && hasGsap) {
    const num = loader.querySelector('.loader-num');
    const obj = { v: 0 };
    const tl = gsap.timeline({ onComplete: () => { loader.remove(); sessionStorage.setItem('goy-seen', '1'); ScrollTrigger.refresh(); } });
    if (!seen) {
      tl.to(obj, { v: 100, duration: 1.3, ease: 'power2.inOut', onUpdate: () => num.textContent = Math.round(obj.v) })
        .to(loader.querySelector('.loader-inner'), { yPercent: -30, opacity: 0, duration: .5, ease: 'power3.in' }, '-=.1')
        .to(loader, { clipPath: 'inset(0 0 100% 0)', duration: .9, ease: 'expo.inOut' }, '-=.25')
        .add(() => html.classList.add('loaded'), '-=.6');
    } else {
      tl.to(loader, { opacity: 0, duration: .45, ease: 'power2.out' }).add(() => html.classList.add('loaded'), '-=.4');
    }
  } else finishLoad();
  setTimeout(() => { html.classList.add('loaded'); document.getElementById('loader')?.remove(); }, 4500);

  if (reduce || !hasGsap) { document.querySelectorAll('.split').forEach(el => el.classList.add('in')); return; }
  gsap.registerPlugin(ScrollTrigger);

  /* ---------- Lenis smooth scroll ---------- */
  let lenis = null;
  if (typeof Lenis !== 'undefined') {
    lenis = new Lenis({ lerp: .1, wheelMultiplier: 1, smoothWheel: true });
    html.style.scrollBehavior = 'auto';
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
    document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
      const t = document.querySelector(a.getAttribute('href')); if (!t) return;
      e.preventDefault(); lenis.scrollTo(t, { offset: -80, duration: 1.2 });
    }));
  }

  /* ---------- Scroll progress ---------- */
  const prog = document.querySelector('.progress');
  if (prog) gsap.to(prog, { scaleX: 1, ease: 'none', scrollTrigger: { start: 0, end: 'max', scrub: .3 } });

  /* ---------- Page transitions ---------- */
  const curtain = document.querySelector('.curtain');
  if (curtain) {
    document.querySelectorAll('a[href$=".html"], a[href*=".html#"]').forEach(a => a.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || a.target === '_blank') return;
      e.preventDefault();
      gsap.to(curtain, { clipPath: 'inset(0 0 0% 0)', duration: .6, ease: 'expo.inOut', onComplete: () => location.href = a.href });
    }));
  }

  /* ---------- Split text ---------- */
  const split = el => {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.className = 'wi'; i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('w')) walk(n);
      });
    };
    walk(el);
  };
  document.querySelectorAll('.split').forEach(el => {
    split(el);
    gsap.fromTo(el.querySelectorAll('.wi'), { yPercent: 110, rotate: 2 }, {
      yPercent: 0, rotate: 0, duration: 1.1, ease: 'expo.out', stagger: .035,
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  });

  /* ---------- Hero ---------- */
  const hero = document.querySelector('.hero');
  if (hero) {
    const card = hero.querySelector('.hero-card');
    const media = hero.querySelector('.hero-card video, .hero-card img');
    gsap.fromTo(media, { scale: 1.25 }, { scale: 1, duration: 2.2, ease: 'expo.out', delay: seen ? .2 : 1.6 });
    gsap.to(card, { yPercent: 10, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to(hero.querySelector('.hero-copy'), { yPercent: -8, opacity: .35, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    const orb = hero.querySelector('.hero-orb');
    if (orb && fine) hero.addEventListener('pointermove', e => {
      const r = hero.getBoundingClientRect();
      gsap.to(orb, { x: (e.clientX - r.left - r.width * .7) * .25, y: (e.clientY - r.top - r.height * .7) * .25, duration: 1.2, ease: 'power3.out' });
    });
  }

  /* ---------- Marquee (Geschwindigkeit folgt Scroll) ---------- */
  document.querySelectorAll('.marquee').forEach(m => {
    const row = m.querySelector('.marquee-row');
    row.innerHTML += row.innerHTML;
    const tween = gsap.to(row, { xPercent: -50, duration: 28, ease: 'none', repeat: -1 });
    ScrollTrigger.create({ onUpdate: s => { gsap.to(tween, { timeScale: 1 + Math.min(Math.abs(s.getVelocity()) / 600, 4), duration: .4, overwrite: true }); } });
  });

  /* ---------- Reveals (Bilder clip, Karten stagger) ---------- */
  document.querySelectorAll('.clip-reveal').forEach(el => {
    const img = el.querySelector('img, video');
    gsap.fromTo(el, { clipPath: 'inset(12% 8% 12% 8% round 40px)' }, { clipPath: 'inset(0% 0% 0% 0% round 40px)', duration: 1.4, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
    if (img) gsap.fromTo(img, { scale: 1.2 }, { scale: 1.02, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
  });
  document.querySelectorAll('[data-stagger]').forEach(group => {
    const items = group.querySelectorAll(group.dataset.stagger);
    gsap.fromTo(items, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: 'expo.out', stagger: .07, scrollTrigger: { trigger: group, start: 'top 85%', once: true } });
  });
  document.querySelectorAll('.rise').forEach(el => {
    gsap.fromTo(el, { y: 36, opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
  });
  document.querySelectorAll('[data-parallax]').forEach(el => {
    gsap.to(el, { yPercent: +el.dataset.parallax, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  /* ---------- Count-up ---------- */
  document.querySelectorAll('[data-count]').forEach(el => {
    const target = parseFloat(el.dataset.count), suffix = el.dataset.suffix || '', dec = el.dataset.dec ? 2 : 0;
    const o = { v: 0 };
    gsap.to(o, { v: target, duration: 1.6, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true },
      onUpdate: () => el.textContent = o.v.toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix });
  });

  /* ---------- Horizontal Bestseller (Desktop) ---------- */
  const hs = document.querySelector('.hscroll:not(.is-grid)');
  if (hs) {
    const mm = gsap.matchMedia();
    mm.add('(min-width: 900px)', () => {
      const track = hs.querySelector('.scroller');
      hs.classList.add('is-pinned');
      const getX = () => -(track.scrollWidth - hs.clientWidth + 48);
      gsap.to(track, { x: getX, ease: 'none', scrollTrigger: { trigger: hs, start: 'top top', end: () => '+=' + (track.scrollWidth - hs.clientWidth), pin: true, scrub: .5, invalidateOnRefresh: true } });
      ScrollTrigger.refresh();
      return () => hs.classList.remove('is-pinned');
    });
  }

  /* ---------- Pinned Story (drei Kapselcremes als Slides) ---------- */
  const story = document.querySelector('.story');
  if (story && !matchMedia('(max-width: 900px)').matches) {
    const panels = story.querySelectorAll('.story-panel');
    const stage = story.querySelector('.story-stage');
    const media = stage.querySelectorAll(':scope > img, :scope > video, :scope > .story-seq');
    const bar = story.querySelector('.story-bar i');
    const cuts = story.querySelectorAll('.story-cuts img');
    const sectionWashes = ['#BFD7EA', '#F4D9A6', '#F6C6D3'];   // ganze Section, vollflächig
    const bubbleColors  = [[88,140,200], [225,150,40], [230,100,150]]; // Kapseln: Blau, Gold, Rosa
    const n = panels.length;
    const tl = gsap.timeline({ scrollTrigger: { trigger: story, start: 'top top', end: '+=' + (n * 90) + '%', pin: true, scrub: .6 } });
    const seqTimers = new WeakMap();
    const show = (el, on) => {
      if (!el) return;
      if (el.tagName === 'VIDEO') { on ? el.play().catch(() => {}) : el.pause(); return; }
      if (el.hasAttribute('data-seq')) {                       // Bildsequenz: Vollbild setzt zurück, Kacheln/Chips stapeln sich
        clearInterval(seqTimers.get(el));
        const steps = [...el.children]; let i = steps.findIndex(f => f.classList.contains('is-cur')); if (i < 0) i = 0;
        if (on && steps.length > 1 && !reduce) seqTimers.set(el, setInterval(() => {
          i = (i + 1) % steps.length; const st = steps[i];
          if (st.classList.contains('f-full') || i === 0) steps.forEach(x => x.classList.remove('is-cur'));
          st.classList.add('is-cur');
        }, 700));
      }
    };
    panels.forEach((p, i) => {
      if (i > 0) {
        tl.to(panels[i - 1], { yPercent: -10, opacity: 0, duration: .8, ease: 'power2.in' }, i - .2);
        tl.fromTo(p, { yPercent: 10, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, ease: 'power2.out' }, i);
        if (media[i - 1]) tl.to(media[i - 1], { opacity: 0, scale: 1.08, duration: .8, ease: 'power2.in', onStart: () => show(media[i - 1], false), onReverseComplete: () => show(media[i - 1], true) }, i - .2);
        if (media[i]) tl.fromTo(media[i], { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1, duration: 1, ease: 'power2.out', onStart: () => show(media[i], true), onReverseComplete: () => show(media[i], false) }, i - .1);
        if (cuts[i - 1]) tl.to(cuts[i - 1], { opacity: 0, y: 24, rotate: -4, duration: .6, ease: 'power2.in' }, i - .15);
        if (cuts[i]) tl.fromTo(cuts[i], { opacity: 0, y: 40, rotate: 6 }, { opacity: 1, y: 0, rotate: 0, duration: .9, ease: 'back.out(1.4)' }, i + .05);
      }
      if (!matchMedia('(max-width: 900px)').matches) tl.to(story, { backgroundColor: sectionWashes[i], duration: 1 }, i);
    });
    if (bar) tl.fromTo(bar, { scaleX: 0 }, { scaleX: 1, duration: n, ease: 'none' }, 0);
    show(media[0], true);

    /* Kapsel-Ebene: Canvas hinter der Section, 3 Tiefen, driftet + Scroll-Parallax, färbt sich pro Slide um, "platzt" beim Wechsel */
    const cv = story.querySelector('.story-bubbles');
    if (cv && !reduce) {
      const ctx = cv.getContext('2d');
      const mobile = matchMedia('(max-width: 900px)').matches;
      const COUNT = mobile ? 12 : 28;
      let W = 0, H = 0, dpr = 1, bubbles = [], pops = [], lastIdx = 0, t0 = performance.now();
      const rnd = (a, b) => a + Math.random() * (b - a);
      const resize = () => {
        dpr = Math.min(devicePixelRatio || 1, 2);
        W = story.clientWidth; H = story.clientHeight;
        cv.width = W * dpr; cv.height = H * dpr; cv.style.width = W + 'px'; cv.style.height = H + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (!bubbles.length) for (let i = 0; i < COUNT; i++) {
          const depth = i % 3;                              // 0 hinten, 2 vorne
          bubbles.push({ x: rnd(0, 1), y: rnd(0, 1), r: [rnd(10, 22), rnd(18, 34), rnd(28, 54)][depth], depth,
            a: [.22, .34, .5][depth], vx: rnd(-.012, .012), vy: rnd(-.02, -.006) * (depth + 1) / 2, ph: rnd(0, 6.28) });
        }
      };
      const lerp = (a, b, t) => a + (b - a) * t;
      const colorAt = (p) => {                                 // Mischfarbe zwischen den Slides
        const f = Math.min(n - 1, Math.max(0, p * n - .5)); const i = Math.floor(f), t = f - i, A = bubbleColors[i], B = bubbleColors[Math.min(n - 1, i + 1)];
        return [lerp(A[0], B[0], t), lerp(A[1], B[1], t), lerp(A[2], B[2], t)].map(Math.round);
      };
      const drawBubble = (x, y, r, col, a) => {
        const g = ctx.createRadialGradient(x - r * .35, y - r * .4, r * .1, x, y, r);
        g.addColorStop(0, `rgba(255,255,255,${a * .9})`);
        g.addColorStop(.35, `rgba(${col[0]},${col[1]},${col[2]},${a})`);
        g.addColorStop(1, `rgba(${col[0]},${col[1]},${col[2]},${a * .55})`);
        ctx.beginPath(); ctx.arc(x, y, r, 0, 6.283); ctx.fillStyle = g; ctx.fill();
        ctx.beginPath(); ctx.arc(x - r * .3, y - r * .35, r * .18, 0, 6.283); ctx.fillStyle = `rgba(255,255,255,${a * .8})`; ctx.fill();
      };
      let visible = false, raf = 0;
      const frame = (now) => {
        if (!visible) { raf = 0; return; }
        const time = (now - t0) / 1000, p = tl.progress(), col = colorAt(p);
        const idx = Math.min(n - 1, Math.floor(p * n));
        if (idx !== lastIdx) { lastIdx = idx; for (let k = 0; k < 7; k++) { const b = bubbles[Math.floor(Math.random() * bubbles.length)]; pops.push({ x: b.x, y: b.y, r: b.r, t: 0 }); } }
        ctx.clearRect(0, 0, W, H);
        for (const b of bubbles) {
          const drift = Math.sin(time * .6 + b.ph) * .012;
          const px = ((b.x + b.vx * time * .15 + drift) % 1 + 1) % 1;
          const py = ((b.y + b.vy * time * .15 - p * (.25 + b.depth * .25)) % 1 + 1) % 1;   // Parallax: vorne schneller
          drawBubble(px * W, py * H, b.r * (1 + Math.sin(time + b.ph) * .04), col, b.a);
        }
        pops = pops.filter(o => o.t < 1);
        for (const o of pops) { o.t += .05; const e = 1 - Math.pow(1 - o.t, 3); ctx.beginPath(); ctx.arc(o.x * W, o.y * H, o.r * (1 + e * 1.6), 0, 6.283); ctx.strokeStyle = `rgba(${col[0]},${col[1]},${col[2]},${(1 - o.t) * .6})`; ctx.lineWidth = 2 * (1 - o.t) + .5; ctx.stroke(); }
        raf = requestAnimationFrame(frame);
      };
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible && !raf) raf = requestAnimationFrame(frame); }, { rootMargin: '20%' }).observe(story);
      resize(); addEventListener('resize', resize);
    }
  }

  /* ---------- Tilt (Sorten-Bühne, Galerie) ---------- */
  if (fine) document.querySelectorAll('[data-tilt]').forEach(el => {
    el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      gsap.to(el, { rotateY: x * 8, rotateX: -y * 8, transformPerspective: 900, duration: .8, ease: 'power3.out' });
    });
    el.addEventListener('pointerleave', () => gsap.to(el, { rotateX: 0, rotateY: 0, duration: 1, ease: 'expo.out' }));
  });

  /* ---------- Custom Cursor + Magnetic ---------- */
  if (fine) {
    const dot = document.createElement('div'); dot.className = 'cursor-dot';
    const ring = document.createElement('div'); ring.className = 'cursor-ring'; ring.innerHTML = '<span></span>';
    document.body.append(dot, ring);
    html.classList.add('has-cursor');
    const pos = { x: innerWidth / 2, y: innerHeight / 2 }, ringPos = { ...pos };
    addEventListener('pointermove', e => { pos.x = e.clientX; pos.y = e.clientY; gsap.set(dot, { x: pos.x, y: pos.y }); });
    gsap.ticker.add(() => { ringPos.x += (pos.x - ringPos.x) * .16; ringPos.y += (pos.y - ringPos.y) * .16; gsap.set(ring, { x: ringPos.x, y: ringPos.y }); });
    document.querySelectorAll('a, button, [data-cursor]').forEach(el => {
      el.addEventListener('pointerenter', () => { ring.classList.add('is-hover'); const t = el.closest('[data-cursor]')?.dataset.cursor; if (t) { ring.classList.add('has-label'); ring.querySelector('span').textContent = t; } });
      el.addEventListener('pointerleave', () => ring.classList.remove('is-hover', 'has-label'));
    });
    document.querySelectorAll('.btn, .pcard-atc, .cart-btn, .scroller-nav button').forEach(b => {
      b.addEventListener('pointermove', e => { const r = b.getBoundingClientRect(); gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * .3, y: (e.clientY - r.top - r.height / 2) * .3, duration: .5, ease: 'power3.out' }); });
      b.addEventListener('pointerleave', () => gsap.to(b, { x: 0, y: 0, duration: .8, ease: 'expo.out' }));
    });
  }

  /* ---------- Sorten-Wechsel: weicher Farbwechsel ---------- */
  document.querySelectorAll('[data-flavors] [data-flavor]').forEach(t => t.addEventListener('click', () => {
    const stage = t.closest('[data-flavors]').querySelector('.flavor-stage');
    gsap.to(stage, { backgroundColor: t.dataset.wash, duration: .8, ease: 'power2.out' });
    gsap.fromTo(stage.querySelector('img.is-on'), { scale: 1.06 }, { scale: 1, duration: 1.2, ease: 'expo.out' });
  }));

  /* ---------- Footer Wortmarke ---------- */
  const big = document.querySelector('.foot-big');
  if (big) gsap.fromTo(big, { yPercent: 30, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.4, ease: 'expo.out', scrollTrigger: { trigger: big, start: 'top 95%', once: true } });

  /* ---------- Kategorie-Filter: FLIP-artig ---------- */
  document.querySelectorAll('[data-filter]').forEach(ch => ch.addEventListener('click', () => {
    const cards = document.querySelectorAll('[data-filter-grid] .pcard:not([hidden])');
    gsap.fromTo(cards, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: .6, ease: 'expo.out', stagger: .04, clearProps: 'all' });
    ScrollTrigger.refresh();
  }));

  ScrollTrigger.sort();
  addEventListener('load', () => setTimeout(() => ScrollTrigger.refresh(), 100));
  document.fonts?.ready.then(() => ScrollTrigger.refresh());
})();
